import { render } from "./EmailOnboardingMode.vue?vue&type=template&id=c617a388&scoped=true"
import script from "./EmailOnboardingMode.vue?vue&type=script&lang=js"
export * from "./EmailOnboardingMode.vue?vue&type=script&lang=js"

import "./EmailOnboardingMode.vue?vue&type=style&index=0&id=c617a388&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c617a388"]])

export default __exports__